import {useCallback, useEffect, useState, useMemo} from 'react';
import {TopCardImg} from '@/interfaces/specialDisease';
import SvgIcon from '@/components/common/svgIcon';
import {navigate} from '@/utils/navigate';
import * as Logger from '@/utils/ubcUtils';
import {useSearchParams} from '@/hooks/router';
import {getTopicVp} from '@/services/pages/channel/channel.client';
import useJumpUrl from '@/hooks/useJumpUrl';
import {VALUE_TYPE} from '@/dicts/consts';
import styles from './index.less';

interface Props {
    infos: TopCardImg;
    page?: string;
    channelBusinessLine?: string;
    channelId?: string;
}

const DiseaseTopCard = ({infos, page, channelBusinessLine, channelId = ''}: Props) => {
    const {navigateToUrl} = useJumpUrl();
    const handleClick = useCallback(
        () => {
            if (infos?.thirdUrl) {
                const urlParams = {
                    linkUrl: infos.thirdUrl,
                };
                const logParams = {};
                navigateToUrl(urlParams, logParams);
            }
        },
        [infos.thirdUrl, navigateToUrl]
    );

    const query = useSearchParams();

    const [readNum, setReadNum] = useState<string>('');

    const splitNumber = (num: number) => {
        if (typeof num !== 'number') {
            return '';
        }

        return (`${num}`).split('').reverse()
            .join('')
            .replace(/(\d{3})/g, '$1,')
            .replace(/,$/, '')
            .split('')
            .reverse()
            .join('');
    };

    const fetchData = async () => {
        if (!infos.id || !infos.moduleId) {
            return;
        }
        try {
            const data = await getTopicVp({
                id: (infos.id),
                // eslint-disable-next-line camelcase
                sf_ch: (infos.sf_ch),
                moduleId: infos.moduleId,
            });
            if (data.pv) {
                setReadNum(String(splitNumber(Number(data.pv))));
            }


        } catch (e) {
            // eslint-disable-next-line no-console
            console.log(e);
        }
    };

    useEffect(
        () => {
            if (infos.readNum) {
                setReadNum(String(splitNumber(Number(infos.readNum))));
            }
            setInterval(() => {
                fetchData();
            }, 4000);
        },
        []
    );

    const handleClickBtn = useCallback(
        () => {
            if (infos?.floatBtnUrl) {
                Logger.clk({
                    page: 'vote_index',
                    value: 'rule',
                    ext: {
                        // eslint-disable-next-line camelcase
                        sf_ref: query.channel,
                        id: query.id,
                    },
                });
                navigate(infos.floatBtnUrl);
            }
        },
        [infos.floatBtnUrl, query.channel, query.id]
    );

    const renderFloatBtn = useMemo(
        () => (
            <div className={styles.floatBtn} onClick={handleClickBtn}>
                <div className={styles.text}>{infos?.floatBtnText}</div>
                <div><SvgIcon name="right" width={8} height={8} /></div>
            </div>
        ),
        [handleClickBtn, infos?.floatBtnText]
    );

    return (
        <div
            className={styles.parent}
            data-show={JSON.stringify({
                'page': page,
                'value': 'jump_toutu',
                'pageSourceId': channelId,
                'pageType': channelBusinessLine,
                'valueId': infos.moduleId,
                'valueTitle': infos.moduleName,
                'valueType': VALUE_TYPE.MODULE,
            })}
        >
            {infos?.floatBtnText && renderFloatBtn}
            <img
                onClick={() => {}}
                className={styles.topCardBg}
                src={infos.bgImage}
            />
            {infos?.hasMask === 1 ? <div className={styles.mask} /> : null}
            <div
                className={styles.contentParent}
            >
                <div
                    className={styles.logoParent}
                >
                    <img
                        onClick={() => {}}
                        src={infos.selfLogo}
                        className={styles.logo}
                    />
                    {
                        infos.selfLogo && (infos.thirdLogo || infos.thirdName)
                            ? <span className={styles.line} />
                            : null

                    }
                    <img
                        src={infos.thirdLogo}
                        className={styles.logo}
                        onClick={() => handleClick()}
                    />
                    <span
                        className={styles.name}
                        onClick={() => handleClick()}
                    >
                        {infos.thirdName}
                    </span>
                </div>
                <span
                    className={styles.title}
                >
                    {infos.title}
                </span>

                {
                    readNum
                        ? (
                            <div
                                className={styles.countText}
                            >
                                <span>
                                    累计阅读次数：
                                </span>
                                <span
                                    className={styles.count}
                                >
                                    {readNum}
                                </span>
                                <span>
                                    次
                                </span>
                            </div>
                        )
                        : null
                }
            </div>
        </div>
    );
};

export default DiseaseTopCard;
